import { useScrollContext } from "../Scroll"
import { useNavigation } from "../../providers/NavigationProvider"
import { useEffect, useId } from "react"
import dynamic from "next/dynamic"

export function dynamicWithLoader(options, children = undefined) {
	return dynamic(options, {
		loading: () => <Loading>{children}</Loading>,
		ssr: false,
	})
}

export const Loading = () => {
	const id = useId()
	const scroll = useScrollContext()
	const navigation = useNavigation()

	useEffect(() => {
		navigation.markComponentLoading(id)

		return () => {
			scroll.refresh()
			navigation.markComponentLoaded(id)
		}
	}, [])

	return null
}

export default dynamicWithLoader
